<!-- RDV PRESCRIPTEUR -->
<div class="col">
	<div class="border border-light border-5 rounded bg-light h-100">
		<div class="row mt-2 mb-3 text-center justify-content-center">
			<i class="bi bi-calendar-check-fill fs-1" aria-hidden="true"></i>
			<span
				*ngIf="listAppointments.length > 0"
				class="theme-main-color fw-bold fs-4"
			>
				Nouveau{{ manyNewAppointments ? 'x' : '' }} RDV Prescripteur en attente
			</span>
			<span
				*ngIf="listAppointments.length === 0"
				class="theme-main-color fw-bold fs-4"
			>
				Pas de nouveaux RDV
			</span>
		</div>
		<div class="row mb-3">
			<div class="row" *ngFor="let appointment of listAppointments">
				<div class="row ms-2">
					<span class="theme-main-color">
						Nouveau RDV enregistré à
						<span class="theme-main-color fw-bold"
							>{{ formatTime(appointment.startTime) }} -
							{{ formatTime(appointment.endTime) }}</span
						>
						le
						<span class="theme-main-color fw-bold">{{
							appointment.date | date : 'mediumDate'
						}}</span>
						avec
						<span class="theme-main-color fw-bold">{{
							appointment.prescriber.name
						}}</span>
						<!-- Bouton de planification avec icône -->
						<a
							class="btn theme-main-color-button mt-2 ms-2 align-baseline"
							(click)="navigateToAddForm(appointment)"
							role="button"
						>
							<i class="bi bi-calendar-plus"></i> Planifier
						</a>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
